import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi, FullCalendarModule , FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput } from '@fullcalendar/core';
import { Draggable } from '@fullcalendar/interaction';
import { FormControl, FormGroup } from '@angular/forms';
import { AccountService } from 'app/_services/account.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { SubmissionService } from '../_services/submission.service';
import { ClientService } from 'app/_services/client.service';
import { BuildingService } from 'app/_services/building.service';
import { NoteService } from 'app/_services/note.service';
import { ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment'; 

@Component({
  selector: 'app-calendar-foreman',
  templateUrl: './calendar-foreman.component.html',
  styleUrls: ['./calendar-foreman.component.scss']
})
export class CalendarForemanComponent implements OnInit {
  @ViewChild('calendar', { static: false }) calendar!: FullCalendarComponent;

  contactUUID: string = "";
  salesList: any = [];
  submissionsList: any[] = [];
  submissionsNotAssignedList: any[] = [];

  submitSubmissionInfoSuccess: boolean = false;
  submitBuildingInfoSuccess: boolean = false;
  showMessage: boolean = false;
  messageSuccess: string = "Mise à jour effectuée";
  messageError: string = "Une erreur c'est produit";

  submissionId: number = 0;
  eventSubmissionInfo: any = {};
  eventBuildingInfo: any = [];
  clientId: number = 0;
  clientInfo: any = [];
  buildingId: number = 0;
  popover_on: any = false;

  followUps: any = [];
  oldStartDate: string = "";
  oldEndDate: string = "";
  startDate: string = "";
  endDate: string = "";
  eventModal: any;
  eventName: string = "";
  submissionInfo: any = [];
  modalTitle: string = "";
  eventAddress: string = "";
  eventStartDate: any;
  eventEndDate: any;
  calendarApi: any;
  no_results_message: string = "";
  isSearch: boolean = false;
  p: number = 0;
  total: number = 0;

  /*------------------------------------------
  --------------------------------------------
  Define calendarOptions
  --------------------------------------------
  --------------------------------------------*/
  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    buttonText: {
      today: 'Aujourdhui',
      month: 'Mois',
      week: 'Semaine',
      day: 'Jour',
      list: 'Liste',
    },
    height: 'auto',
    eventDisplay:'block',
    initialView: 'dayGridMonth',
    // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
    weekends: true,
    firstDay: 1,
    editable: false,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: 99,
    lazyFetching: true,
    progressiveEventRendering: false,
    droppable: false, // this allows things to be dropped onto the calendar
    //drop: this.handleDropEvent.bind(this),
    //eventDrop: this.handleDragEvent.bind(this),
    eventClick: this.handleEventClick.bind(this),
    datesSet: this.handleEvents.bind(this),
    dateClick: this.handleDateClick.bind(this),
    events: [],
  };

  searchSubmissionForm: FormGroup = new FormGroup({
    search_submission: new FormControl("")
  })

  constructor(
    private account: AccountService,
    private tokenStorage: TokenStorageService,
    private submission: SubmissionService,
    private submissions: SubmissionService,
    private clients: ClientService,
    private buildings: BuildingService,
    private notes: NoteService,
    private refchanges: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.getSubmissions();
  }

  getSubmissions(): void {
    // Searching criterias
    // is_scheduled = false
    // is_job_planned = false
    // limit = 9999
    let searchInfo = "state?is_signed=true&is_accepted=true&is_refused=false&has_invoice=false&limit=9999";    //"state?is_scheduled=true&is_job_planned=false&limit=9999";
    
    this.submission.searchStateSubmission$(this.contactUUID, searchInfo, 0).subscribe({
      next: (data: any) => {
        console.log("submissions Not Assigned List", data)
        this.submissionsNotAssignedList = data.records

        let draggableEl = document.getElementById('external-events')!;

        new Draggable(draggableEl, {
          itemSelector: '.client-event',
          eventData: function (eventEl) {
            console.log("Setting id", eventEl.id);
            return {
              id: eventEl.id,
              title: eventEl.innerText
            };
          }
        });
      },
      error: (err: any) => {
        console.log("Something went wrong with searching the submissions: ", err)
      }
    })

  }

  //load events
  loadEvents(): void {

    //this.calendarApi = this.calendar.getApi();
   // console.log('vendeur: ', event.target.value, this.editCalendarForm.controls['submissions_by_sales'].value);
    const dates = this.calendarApi.getCurrentData();

    console.log('****************LOADING start date',this.startDate);

    //console.log(this.calendarApi.currentData.currentDate );
    //console.log('dates', this.startDate, this.saleAccountId, this.contactUUID);
  
    this.notes.getCalendrierForeman$(this.contactUUID, moment(this.startDate).format('YYYY-MM-DD')).subscribe({
      next: (data: any) => {
        console.log("Notes list ", data)
        this.submissionsList = [];

        for(let i = 0; i < data.length; i++) {

          let color: string = "#3788d8";

          if (data[i].has_invoice) {
            color = "#006633";//green
          }
          
          if (data[i].is_refused) {
            color = "#bb0200";//red
          }

          let address = "#" + 
                        data[i].submission_no +
                        " " + 
                        data[i].client_first_name +
                        " " + 
                        data[i].client_last_name +
                        " - " + 
                        data[i].address + 
                        " " + 
                        (data[i].address2||"") ;
           
          //console.log('client: ',address, color);
          this.submissionsList.push(
            {
              "id": data[i].note_id,
              "title": address,
              "start": moment(data[i].start_date).format('YYYY-MM-DD HH:mm'), // We need to select a date
              "end": moment(data[i].end_date).format('YYYY-MM-DD HH:mm'),
              "backgroundColor": color,
              "extendedProps": data[i],
              "className": 'event-style' ,
            }
          )
        }

        console.log("calendar list", this.submissionsList);
        this.calendarOptions.events = this.submissionsList;

        //console.log("this.calendarOptions.events ", this.calendarOptions.events)
      },
      error: (err: any) => {
        console.log("Something went wrong with getting the calendar submissions: ", err)
      }
    })
}

  //load events for date change
  handleEvents(events: any): void {
    console.log('handling events');
    
    this.calendarApi = this.calendar.getApi();
    const dates = this.calendarApi.getCurrentData();
    this.startDate = moment(dates.dateProfile.activeRange!.start).format('YYYY-MM-DD HH:mm');
    this.endDate = moment(dates.dateProfile.activeRange!.end).format('YYYY-MM-DD HH:mm');

   // console.log('this.startDate',  this.startDate);
    //console.log('this.endDate',  this.endDate);
    this.loadEvents();

    if (this.oldStartDate !== this.startDate) {
      this.oldStartDate = this.startDate
    }

    this.closePopovers();
  }
  
  //dropping event onto calendar
  handleDropEvent(event: any) {
    console.log('dropping event ', event.dateStr);
    console.log('sub id ', event.draggedEl.id);
    console.log('New JOB EVENT ',event);
    // Delete the submission of the left menu
    event.draggedEl.parentElement.remove();
    

    const draggedEventId = event.draggedEl.id;
    const draggedEventDate = event.dateStr;

    console.log('Submission DRAGGED', event.draggedEl);
    this.getEventSubmissionNew(event, draggedEventId, draggedEventDate);
  }

  handleDragEvent(eventDragged: any) {
    console.log('drag event ', eventDragged);
    console.log('event id ', eventDragged.event._def.extendedProps.note_id);
    const draggedEventId = eventDragged.event._def.extendedProps.submission_id;
    const draggedEventDate = eventDragged.event.startStr;
    const draggedEventNoteId = eventDragged.event._def.extendedProps.note_id;
    const draggedEventNoteUpdated = eventDragged.event._def.extendedProps.updated;

    this.getEventSubmission(draggedEventId, draggedEventDate, draggedEventNoteId, draggedEventNoteUpdated, eventDragged );
  }

  handleEventClick(clickInfo: EventClickArg): void {
    const submissionInfo = clickInfo.event._def.extendedProps;

    this.popover_on = !this.popover_on;

    console.log("clickInfo", clickInfo)
    console.log("clickInfo", submissionInfo)

    this.closePopovers();

    //@ts-ignore
    const eventPopover = new bootstrap.Popover(clickInfo.el, {
      animation: true,
      container: "body",
      html: true,
      placement: "auto",
      trigger: "focus",
      sanitize: false,
      title: '', //clickInfo.event.title
      content:
      
            '<div class="d-flex"><span class="mb-2">' + "#" + submissionInfo['submission_no'] + ' <strong >' + submissionInfo['client_first_name'] + " " + submissionInfo['client_last_name'] + '</strong ></span></div>' +
              '<div class="buttons-wrapper">' +
              '</div>' + 
              '<div class="d-flex justify-content-end action-icons">' +
                '<a type="button" class="btn btn-outline-secondary action-btn" href="/soumission/' + submissionInfo['submission_id'] + '/editer">' +
                  '<i class="bi bi-pencil-square" title="Voir la soumission"></i>' +
                '</a>' +
              '</div>'
    })

    if (this.popover_on) {
      eventPopover.show();

    }
    else {
      this.closePopovers();
    }
  }

  //register dropped date event, is job planned, update date
  getEventSubmission(submissionId: number, eventDate: string, NoteId: number,  noteUpdated: string, event: any) {
    this.submissions.getSubmission$(submissionId, this.contactUUID).subscribe({
      next: data => {
        this.submissionId = data.submission_id;
        this.buildingId = data.building_id;

        //this.getEventBuildingInfo(eventDate);

        console.log('id being updated', this.submissionId);
        console.log('note is', NoteId);
        
        console.log('note updated',data.state_updated);
        console.log('note is', NoteId);
        let note_updated :string = noteUpdated;
        
        let eventSubmissionInfo = {
          "submission_state_id": data.submission_state_id,
          "is_job_planned": true,
          "updated": data.state_updated
        }

        let eventNoteInfo = {
          "note_id": NoteId,
          "start_date": eventDate,
          "end_date": eventDate,
          "updated": note_updated,
        }
        //bring back note updated into the array above, have to get it first

         console.log("EVENT SUBMISSION INFO ", eventSubmissionInfo)
         console.log("EVENT NOTE INFO ", eventNoteInfo)
        this.submitSubmissionInfo(eventSubmissionInfo, event);
        this.submitNoteInfo(eventNoteInfo);
      },
      error: err => {
        console.log("Something went wrong fetching submission: ", err)
      }
    });
  }

  //register dropped date event, is job planned, update date
  getEventSubmissionNew(currEvent:any, submissionId: number, eventDate: string ) {
    this.submissions.getSubmission$(submissionId, this.contactUUID).subscribe({
      next: data => {
        this.submissionId = data.submission_id;
        this.buildingId = data.building_id;
        //this.getEventBuildingInfo(eventDate);
        console.log('id being updated', this.submissionId);
        
        let eventSubmissionInfo = {
          "submission_state_id": this.submissionId,
          "is_job_planned": true,
          "updated": data.state_updated
        }

        let eventNoteInfo = {
          "note_type_id": 7,
          "note_entity_id": 2,
          "entity_id": this.submissionId,
          "subject": '',
          "body": '',
          "start_date": moment(eventDate),
          "end_date": moment(eventDate),
        }
        //bring back note updated into the array above, have to get it first

         console.log("ADD EVENT SUBMISSION INFO ", eventSubmissionInfo);
         console.log("ADD EVENT NOTE INFO ", eventNoteInfo);
         //console.log("CURR EVENT", currEvent);
         this.submitSubmissionInfo(eventSubmissionInfo,currEvent);
         this.addNoteJob(currEvent, eventNoteInfo, data);
        
      },
      error: err => {
        console.log("Something went wrong fetching submission for NEW job: ", err)
      }
    });
  }

  getEventBuildingInfo(eventDate: string): void {
    this.buildings.getBuilding$(this.contactUUID, this.buildingId).subscribe({
      next: building => {
        this.eventBuildingInfo = {
          "building_id": this.buildingId,
          "updated": building.updated,
          "submission_id": building.submission_id,
          "description": building.description,
          "roof_date": building.roof_date,
          "roof_description": building.roof_description,
          "roof_access": building.roof_access,
          "build_date": eventDate,
          "purchase_date": building.owner_since,
          "is_new": building.is_new,
          "address": building.address,
          "address2": building.address2,
          "city": building.city,
          "province": building.province,
          "country": building.country,
          "postalcode": building.postalcode
        }

        // console.log("EVENTBUILDINGINFO ", this.eventBuildingInfo)
        this.submitBuildingInfo(this.eventBuildingInfo);
      },
      error: err => {
        console.log("Something went wrong fetching building info: ", err)
      }
    });
  }

  submitSubmissionInfo(info: any, event:any): void {
    //const noteInfos = event.view;
    //console.log('SUBMISSION INFO event', noteInfos);

    this.submissions.updateSubmissionState$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission: ", data)
        this.submitSubmissionInfoSuccess = true;
        //refresh calendar


        
       // console.log('added event', noteInfos);
        //noteInfos.setExtendedProp( 'updated', data.updated );
        


        //this.calendar.getApi.name;

       // info.setExtendedProp( 'updated', data.updated );


      },
      error: err => {
        console.log("Something went wrong while updating the submission: ", err)
        this.submitSubmissionInfoSuccess = false;
      }
    });
  }

  submitNoteInfo(info: any): void {
    this.notes.updateNote$(this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the note: ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the note: ", err)
      }
    });
  }

  
  addNoteJob(currEvent:any, info: any, submissionData: any): void {
    this.notes.addSubmissionNote$(this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success adding the JOB note: ", data);

        console.log('submission data', submissionData);
        let color: string = "#3788d8";
        let address = data.note_id + " " + "Contrat #" + 
        submissionData.submission_no +
                      " " + 
                      submissionData.client_first_name +
                      " " + 
                      submissionData.client_last_name +
                      " - " + 
                      submissionData.address + 
                      " " + 
                      submissionData.address2 + 
                      ", " + 
                      submissionData.city ;
         
        this.submissionsList.push(
          {
            "id": data.note_id,
            "title": address,
            "start": moment(data.start_date).format('YYYY-MM-DD HH:mm'), // We need to select a date
            "end": moment(data.end_date).format('YYYY-MM-DD HH:mm'),
            "backgroundColor": color,
            "extendedProps": submissionData,
            "className": 'event-style' ,
          }
        );
        
       
        this.calendarOptions.events = this.submissionsList;
        //window.location.reload();
        this.loadEvents();

        //this.calendarOptions.events = this.submissionsList;
        
        //console.log('submission list ADDED Job', this.submissionsList);
        //console.log('currEvent', currEvent);
        //console.log('currEvent.draggedEl.innerHTML', currEvent.draggedEl.innerHTML);

        currEvent.draggedEl.id = data.note_id;
        currEvent.title = address;
        //currEvent.event._def.extendedProps = currEvent.draggedEl.innerHTML;
        console.log('REFRESH');
        //this.calendar.refresh();

       // this.events = this.submissionsList;
        //this.calendarOptions.events = this.events;


        this.submissionsList= this.submissionsList.slice();
        this.submissionsList= Object.assign([],this.submissionsList);

        //this.calendarApi.refchanges.markForCheck();
      
        /*
        console.log('REFRESH call');

        let something = this.refchanges.detectChanges;

        setTimeout( function( ) {
          //this.calendarApi.render();
          console.log('REFRESH timed out');
          //something();
          console.log('REFRESH after');
          },
        250);
        */

      },
      error: err => {
        console.log("Something went wrong while adding the new job note: ", err)
      }
    });
  }

  submitBuildingInfo(info: any): void {
    this.buildings.updateBuilding$(this.contactUUID, info).subscribe({
      next: (data: any) => {
        console.log("Success updating the building: ", data)
        this.submitBuildingInfoSuccess = true;


        if (this.submitBuildingInfoSuccess === true && this.submitBuildingInfoSuccess === true) {
          this.showMessage = true;
        }
        else {
          this.showMessage = false;
        }
      },
      error: (err: any) => {
        console.log("Something went wrong while updating the building info: ", err)
        this.submitBuildingInfoSuccess = false;
      }
    })
  }

  openModal(info: any): void {
    console.log("info ", info)
  }

  handleDateClick(event: any): void {
    console.log("handleDateClick ", event);
    this.closePopovers();
  }
  
  closePopovers(): void {
    const popoverTriggerList = document.querySelectorAll('.bs-popover-auto');
    for (let i = 0; i < popoverTriggerList.length;i++) {
        console.log("popover", popoverTriggerList[i])
        popoverTriggerList[i].remove();
    }
    this.popover_on = true;
  }

  deleteSuivisNote(note_id: number, noteInfo: any): void {
    this.notes.deleteNote$(this.contactUUID, note_id, noteInfo).subscribe({
      
      next: data => {
        console.log("Success deleting suivi Foreman: ", data);
        this.closePopovers();
        //referesh here
        this.loadEvents();
        //window.location.reload();
  
      },
      error: err => {
          console.log("Something went wrong while deleting suivi Foreman: ", err.error.errors)
      }
      
    });
  }

  onSubmitSearch(values: any): void {
    this.p = 0;
    this.searchSubmission(values.search_submission);
  }

  searchSubmission(search: string): void {
    this.isSearch = true;

    this.submissions.searchSubmissionNoLimit$(this.contactUUID, search, this.p).subscribe({
      next: (data: any) => {
        this.submissionsNotAssignedList = data.records;
        console.log("data.count", data.count);
        console.log("submissions Not Assigned List Search", data)
        let total = data.count;
        if(data.count == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
        else{ this.no_results_message = 'résultat de la recherche: ' + search;}
      },
      error: (err: any) => {
        console.log("Something went wrong searching submissions: ", err.statusText)
      }
    });
  }
}
